module.exports = __webpack_public_path__ + "static/media/growcrazy1.a85a5c38.png";